import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { Skeleton } from '../components/Skeleton';
import { PracticeInfo } from '../components/PracticeInfo';
import { useInitPractice } from '../hooks/useInitPractice';
import { SMART_BOOKING_PARAMS } from '../utils/constants';

export const Landing = () => {
  const { practiceId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { loading, error, practice, init, token } = useInitPractice();

  useEffect(() => {
    if (!practiceId) return;

    const queryParams = new URLSearchParams(location.search);
    const hasSmartBookingParams = SMART_BOOKING_PARAMS.some((param) => queryParams.has(param));

    if (!token) {
      init(practiceId)
        .then(() => {
          if (hasSmartBookingParams) {
            navigate(`bookonline/smart-booking${location.search}`, { replace: true });
          } else {
            navigate(`bookonline/step-1${location.search}`, { replace: true });
          }
        })
        .catch(() => { });
    } else {
      if (hasSmartBookingParams) {
        navigate(`bookonline/smart-booking${location.search}`, { replace: true });
      } else {
        navigate(`bookonline/step-1${location.search}`, { replace: true });
      }
    }
  }, [practiceId, init, navigate, token, location.search]);

  return (
    <Layout>
      {loading && <Skeleton lines={5} />}
      {!loading && error && (
        <div className="alert alert-error">
          <span>{error}</span>
        </div>
      )}
      {!loading && practice && (
        <div className="space-y-4">
          <PracticeInfo />
          <div className="text-sm text-gray-500">Preparing your booking experience…</div>
        </div>
      )}
    </Layout>
  );
};
